import { keyframes as r, css as e } from "../stitches.config.es.js";
const i = r({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), a = e({
  borderRadius: "50%",
  width: "1.5rem",
  height: "1.5rem",
  fontSize: "0.625rem",
  position: "relative",
  border: "0.25rem solid $primary100main",
  borderColor: "$primary100main $primary100main $lightBg20 $lightBg20",
  transform: "translateZ(0)",
  animation: `${i} 1.3s linear infinite`,
  defaultVariants: {
    size: "normal"
  },
  variants: {
    size: {
      small: {
        width: "1.25rem",
        height: "1.25rem",
        borderWidth: "0.125rem"
      },
      normal: {
        width: "1.5rem",
        height: "1.5rem",
        borderWidth: "0.25rem"
      }
    }
  }
});
export {
  i as animation,
  a as loader
};
//# sourceMappingURL=Spinner.styles.es.js.map
